import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { PassdataService } from '../services/passdata.service';

@Component({
  standalone: false,
  selector: 'invd-committed-exchanges-container',
  templateUrl: './committed-exchanges-container.component.html',
  styleUrls: ['./committed-exchanges-container.component.scss'],
})
export class CommittedExchangesContainerComponent {
  private router = inject(Router);
  private passDataService = inject(PassdataService);

  protected trackByIdentity(_index: number, obj: any) {
    return obj;
  }
}
